import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Card, Field, PageTitle, Btn, inputCls } from "./ui";

export default function Security() {
  const [d, setD] = useState(null);
  const [ip, setIp] = useState("");
  const [reason, setReason] = useState("");
  const load = () => api.get("/admin/blocked").then(({ data }) => setD(data));
  useEffect(() => { load(); }, []);

  const block = async (value, why) => {
    try {
      await api.post("/admin/blocked", { ip: value, reason: why });
      toast.success(`${value} blocked`);
      setIp(""); setReason("");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const unblock = async (value) => {
    await api.delete(`/admin/blocked/${encodeURIComponent(value)}`);
    toast.success(`${value} unblocked`);
    load();
  };

  if (!d) return <p className="text-zinc-500">Loading…</p>;
  return (
    <div data-testid="admin-security">
      <PageTitle title="Security" sub="Block spammers and abusive visitors by IP. Visitors over 120 requests/minute are rate-limited automatically." />
      <Card title="Block an IP address">
        <div className="grid gap-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
          <Field label="IP address"><input value={ip} onChange={(e) => setIp(e.target.value)} className={inputCls} placeholder="e.g. 103.21.4.9" data-testid="block-ip-input" /></Field>
          <Field label="Reason"><input value={reason} onChange={(e) => setReason(e.target.value)} className={inputCls} placeholder="Spam clicks" data-testid="block-reason-input" /></Field>
          <Btn onClick={() => ip.trim() && block(ip.trim(), reason)} data-testid="block-ip-submit">Block</Btn>
        </div>
      </Card>
      {d.suspicious.length > 0 && (
        <Card title="Auto-flagged (rate limit hit)" className="mt-6" testid="suspicious-list">
          {d.suspicious.map((s) => (
            <div key={s.ip} className="flex items-center justify-between border-b border-white/5 py-3 last:border-0">
              <div><p className="font-mono text-sm text-white">{s.ip}</p><p className="text-xs text-zinc-500">{s.count} hits over limit · {new Date(s.last_seen).toLocaleString()}</p></div>
              <Btn variant="danger" onClick={() => block(s.ip, "Rate limit abuse")} data-testid={`block-suspicious-${s.ip}`}>Block</Btn>
            </div>
          ))}
        </Card>
      )}
      <Card title={`Blocked IPs (${d.blocked.length})`} className="mt-6" testid="blocked-list">
        {d.blocked.length === 0 ? <p className="text-sm text-zinc-600">No blocked IPs.</p> : d.blocked.map((b) => (
          <div key={b.ip} className="flex items-center justify-between gap-3 border-b border-white/5 py-3 last:border-0" data-testid={`blocked-row-${b.ip}`}>
            <div className="min-w-0"><p className="font-mono text-sm text-white">{b.ip}</p><p className="truncate text-xs text-zinc-500">{b.reason || "No reason"} · {new Date(b.created_at).toLocaleString()}</p></div>
            <Btn variant="outline" onClick={() => unblock(b.ip)} data-testid={`unblock-${b.ip}`}>Unblock</Btn>
          </div>
        ))}
      </Card>
    </div>
  );
}
